// /src/components/mobile/MobileBottomBar.jsx
// Transparent floating bottom bar for mobile (60px).
// Contains: Help button (centre) + Go-to-Top (right, on scroll). The context toggle moved
// to the group header (Mobile Groups, Commit 5) and the ☰ sheet-opener was removed (Commit 7 —
// the identity card's "Group" button opens the sheet), so the bar is now Help + scroll affordances.
// A "Load More" pill also lived here (right, on scroll) until 13 August 2026, when it was removed —
// it dispatched ournet:loadMore, which had no listener anywhere in the app, so it was a no-op on
// click. See docs/briefs/2026-08-13-dead-more-controls-removal.md.

import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';

const MobileBottomBar = ({
  currentContext,
  scrollPosition = 0,
  isNearEndOfContent = false,
  onGoToTop,
  onHelpPress
}) => {
  // Note: useTheme available if needed for future enhancements
  useTheme();

  const getContextColor = () => {
    return currentContext === 'locality' ? '#024B99' : '#BB4D9A';
  };

  // Go-to-Top appears only near the bottom of loaded content
  const showGoToTop = isNearEndOfContent;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: '60px',
      backgroundColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 16px',
      zIndex: 999,
      pointerEvents: 'none' // Allow content below to be tappable
    }}>
      {/* Left: spacer — keeps the Help button centred (context toggle + ☰ both removed). */}
      <div style={{ width: '110px', flexShrink: 0 }} />

      {/* Center: Help button (semi-transparent yellow) */}
      <button
        onClick={onHelpPress}
        style={{
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          backgroundColor: 'rgba(249, 166, 27, 0.85)', // #F9A61B at 85% opacity
          color: '#FFFFFF',
          fontSize: '20px',
          fontWeight: '700',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'auto',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          transition: 'transform 0.2s'
        }}
      >
        ?
      </button>

      {/* Right section: Go to Top button */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        minWidth: '110px',
        justifyContent: 'flex-end'
      }}>
        {/* Go to Top button - only shows when near end of content */}
        {showGoToTop && (
          <button
            onClick={onGoToTop}
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '50%',
              backgroundColor: `${getContextColor()}E6`, // 90% opacity
              color: '#FFFFFF',
              fontSize: '28px',
              fontWeight: 'bold',
              border: 'none',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'transform 0.2s, background-color 0.3s',
              pointerEvents: 'auto',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              paddingBottom: '6px'
            }}
          >
            ▲
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileBottomBar;
